export default "__VITE_ASSET__Bd7PpgWV__"